import { Box, Text, Carousel } from '@stitch-fix/mode-react';
import { Look } from '../../../../../types/definitions/vendor/graphql-schema.d';
import { sortShopProductVariants } from '../../../../../utils/sortShopProductVariants';
import ShopTheLookProductCard from '../ShopTheLookProductCard/ShopTheLookProductCard';
type ShopTheLookProps = {
  items: Look['shopProductVariants'];
};
const ShopTheLook = ({
  items
}: ShopTheLookProps) => {
  if (!items?.length) return null;
  const outfitId = items.map(item => item.sku).join('-');
  const sortedItems = sortShopProductVariants(items);
  if (!sortedItems.length) return null;
  return <Box>
      <Text mb={1.5} setting="title-small">
        Shop the Look
      </Text>
      <Carousel slideWidth={{
      sm: '170px'
    }} ariaLabel="shoppable-items-carousel">
        {sortedItems.map(item => <ShopTheLookProductCard key={item.id} item={item} outfitId={outfitId} />)}
      </Carousel>
    </Box>;
};
export default ShopTheLook;